import React, { useMemo } from "react";
import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import { DarkOrLightType, LIGHT_THEME } from "../common/constants";

interface GoogleAuthProps {
  onSuccess: (credentials: CredentialResponse) => void;
  onError: () => void;
  theme: DarkOrLightType;
}

const GoogleAuth: React.FC<GoogleAuthProps> = ({
  onSuccess,
  onError,
  theme
}) => {
  const onThemeChange = useMemo(() => {
    return theme === LIGHT_THEME ? undefined : "filled_black";
  }, [theme])
  return (
      <GoogleLogin
        theme={onThemeChange}
        onSuccess={onSuccess}
        onError={onError}
      />
  );
};

export default GoogleAuth;
